import { render, staticRenderFns } from "./TagPromocion.vue?vue&type=template&id=05305b87&scoped=true"
import script from "./TagPromocion.vue?vue&type=script&lang=js"
export * from "./TagPromocion.vue?vue&type=script&lang=js"
import style0 from "./TagPromocion.vue?vue&type=style&index=0&id=05305b87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05305b87",
  null
  
)

export default component.exports